import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.544 5a3.958 3.958 0 1 1 7.917 0 3.958 3.958 0 0 1-7.917 0m3.959-2.708a2.708 2.708 0 1 0 0 5.417 2.708 2.708 0 0 0 0-5.417",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.503 11.598c.345 0 .625.28.625.624v.487h.486a.625.625 0 1 1 0 1.25h-.486v.486a.625.625 0 0 1-1.25 0v-.486h-.486a.625.625 0 0 1 0-1.25h.486v-.486c0-.346.28-.626.625-.626"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.815 10.428a12 12 0 0 0-2.312-.22c-1.928 0-3.705.439-5.02 1.18-1.297.729-2.272 1.834-2.272 3.196v.085c-.001.968-.002 2.183 1.064 3.05.524.428 1.258.732 2.25.932.994.202 2.29.308 3.978.308 2.39 0 4.008-.212 5.1-.618.982-.366 1.564-.902 1.875-1.576a3.958 3.958 0 1 0-4.663-6.337m-6.72 2.049c-1.116.628-1.634 1.397-1.634 2.107 0 1.09.034 1.703.603 2.167.309.251.825.496 1.709.675.88.179 2.085.283 3.73.283 2.148 0 3.533-.178 4.425-.458a3.96 3.96 0 0 1-2.962-5.696 11 11 0 0 0-1.463-.096c-1.754 0-3.311.4-4.408 1.018m6.7.857a2.708 2.708 0 1 1 5.416 0 2.708 2.708 0 0 1-5.417 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }